import brandsSlider from './brands-slider.ts'
import ambassadorSlider from './ambassador-slider.ts'
import sectionBanners from './section-banners.ts'
import sectionNews from './section-news.ts'
import sectionReferencesSlider from "./section-references-slider.ts";
import sectionInfoBoxesSlider from "./section-info-boxes-slider.ts";
import sectionFaq from "./section-faq.ts";

export default function () {
	brandsSlider()
	ambassadorSlider()
	sectionBanners()
	sectionNews()
	sectionReferencesSlider()
	sectionInfoBoxesSlider()
	sectionFaq()
}
